
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 -9 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"29","cy":"20","r":"29","fill-opacity":".12"}}),_c('path',{attrs:{"fill":"currentColor","d":"M24 1h12v12h12v12H36v12H24V25H12V13h12z","fill-rule":"nonzero"}})])])
          )
        }
      }
    